import _ from "lodash";
import { useEffect, useState } from "react";
import http from "services/https";
import PopoutA from "./table-statistics/popout-a";
import PopoutB from "./table-statistics/popout-b";

export default function PopoutData({ data, abTest = false, abOngoing = true }) {
  const [reportA, setReportA] = useState(null);
  const [reportB, setReportB] = useState(null);

  useEffect(() => {
    const campaignPopoutId = data.id;
    const baseData = {
      campaign_popup_id: campaignPopoutId,
      start: data.updated_at,
    };
    if (data.popup_a_id) {
      (async () => {
        const popoutId = data.popup_a_id;
        const req = await http.get(
          `reports/get`,
          // We can skip the popout ID if we only have the one, makes the request much quicker!
          data.popup_b_id
            ? {
                ...baseData,
                popup_id: popoutId,
              }
            : baseData
        );
        setReportA(req.data.report);
      })();
    }
    if (data.popup_b_id) {
      (async () => {
        const popoutId = data.popup_b_id;
        const req = await http.get(`reports/get`, {
          ...baseData,
          popup_id: popoutId,
        });
        setReportB(req.data.report);
      })();
    }
  }, [data]);

  const getWinner = () => {
    let result = "A";
    if (!_.isEmpty(data?.preferred_popup)) {
      if (data.preferred_popup.id === data.popup_a_id) {
        result = "A";
      } else if (data.preferred_popup.id === data.popup_b_id) {
        result = "B";
      }
    }
    return result;
  };
  return (
    <div className="flex flex-col space-y-5">
      {/* POPUP A */}
      <PopoutA
        index={`popup-a-test-${data.popup_a_id}`}
        abOngoing={abOngoing}
        data={{ ...data.popup_a, summary: reportA }}
        abTest={abTest}
        type="A"
        winner={getWinner()}
      />

      {/* POPUP B */}
      {data.popup_b_id !== null && (
        <PopoutB
          index={`popup-a-test-${data.popup_b_id}`}
          abOngoing={abOngoing}
          data={{ ...data.popup_b, summary: reportB }}
          type="B"
          winner={getWinner()}
        />
      )}
    </div>
  );
}
